<template>
  <div class="board-detail-wrapper">
    <div class="board-content">
      <div class="detail">
        <div class="title">
          {{ displayBoard ? displayBoard.title : '' }}
        </div>
        <div class="category">
          <div>
            목록
<!--            {{ displayBoard && displayBoard.type == 1 ? '공지' : '뉴스' }}-->
          </div>
          <img :src="detailArrowIcon" width="48" alt="상세 화살표" @click="goToList">
        </div>

        <!-- 이미지를 먼저 표시 -->
        <div class="images" v-if="displayBoard && displayBoard.images && displayBoard.images.length > 0">
          <img
            v-for="(image, index) in displayBoard.images"
            :key="index"
            :src="image"
            :alt="`이미지 ${index + 1}`"
            class="review-image"
          />
        </div>

        <!-- 텍스트 콘텐츠를 이미지 다음에 표시 -->
        <div class="content" v-if="displayBoard" v-html="displayBoard.contents"></div>

        <!-- 첨부파일 다운로드 섹션 -->
        <div class="attachments" v-if=" false && displayBoard && displayBoard.attachments && displayBoard.attachments.length > 0">
          <h3 class="attachments-title">첨부파일</h3>
          <div class="attachment-list">
            <a
              v-for="(attachment, index) in displayBoard.attachments"
              :key="index"
              :href="attachment.download_url || attachment.url"
              :download="attachment.originalname || attachment.name"
              class="attachment-item"
              target="_blank"
            >
              <svg class="download-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 13L6 9H8V4H12V9H14L10 13Z" fill="currentColor"/>
                <path d="M17 15H3V17H17V15Z" fill="currentColor"/>
              </svg>
              <span class="attachment-name">{{ attachment.originalname || attachment.name }}</span>
              <span class="attachment-size" v-if="attachment.size">
                ({{ formatFileSize(attachment.size) }})
              </span>
            </a>
          </div>
        </div>
      </div>

      <button class="btn" @click="goToList">
        목록 보기
      </button>
    </div>
  </div>
</template>

<script>
import detailArrowIcon from "@/assets/icons/icon-detail-arrow.svg";

export default {
  name: 'BoardDetail',
  props: {
    boardId: {
      type: [String, Number],
      required: true
    },
    boards: {
      type: Array,
      default: () => []
    },
    board: {
      type: Object,
      default: null
    },
    listPath: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      detailArrowIcon: detailArrowIcon
    };
  },
  computed: {
    displayBoard() {
      // board prop이 있으면 사용, 없으면 boards 배열에서 찾기!
      if (this.board) {
        return this.board;
      }
      if (this.boards && this.boards.length > 0) {
        return this.boards.find(board => board.id == this.boardId);
      }
      return null;
    }
  },
  methods: {
    goToList() {
      this.$router.push(this.listPath);
    },
    /**
     * 파일 크기를 사람이 읽기 쉬운 형식으로 변환
     * @param {number} bytes - 바이트 크기
     * @returns {string} - 포맷된 파일 크기 (예: "1.5 MB")
     */
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
    }
  }
};
</script>

<style scoped lang="scss">
.board-detail-wrapper {
  width: 100%;
  min-height: 55px;
  margin-top: 80px;
}

.board-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 80px 38px 100px;

  .btn {
    margin-top: 66px;
    font-size: 23.55px;
    line-height: 69.25px;
    text-align: center;
    vertical-align: middle;
    border: 1px solid #222;
    width: 100%;
    cursor: pointer;
    background: white;

    &:hover {
      background: #f5f5f5;
    }
  }
}

.content {
  margin: 60px 0;
  font-size: 18px;
  line-height: 1.8;
  color: #333;

  ::v-deep p {
    margin-bottom: 16px;
    line-height: 1.8;
    word-break: break-all;
  }

  ::v-deep a {
    color: #0066cc;
    text-decoration: underline;
    word-break: break-all;

    &:hover {
      color: #004499;
    }
  }

  // CKEditor 본문 리스트 — 전역 reset.scss(list-style:none) 를 본문 영역에서만 복구
  ::v-deep ul {
    margin: 16px 0;
    padding-left: 24px;
    list-style: disc outside;
    word-break: break-all;

    li {
      margin-bottom: 8px;
      line-height: 1.8;
      display: list-item;
      list-style: inherit;
      word-break: break-all;
    }
  }

  ::v-deep ol {
    margin: 16px 0;
    padding-left: 24px;
    list-style: decimal outside;
    word-break: break-all;

    li {
      margin-bottom: 8px;
      line-height: 1.8;
      display: list-item;
      list-style: inherit;
      word-break: break-all;
    }
  }

  // 중첩 리스트 마커 구분
  ::v-deep ul ul { list-style: circle outside; }
  ::v-deep ul ul ul { list-style: square outside; }

  ::v-deep h2 {
    font-size: 24px;
    font-weight: bold;
    margin: 24px 0 16px;
    word-break: break-all;

  }

  ::v-deep h3 {
    font-size: 20px;
    font-weight: bold;
    word-break: break-all;
    margin: 20px 0 12px;
  }

  ::v-deep img {
    max-width: 100%;
    height: auto;
    word-break: break-all;
    margin: 16px 0;
  }

  // CKEditor 본문 이미지 래퍼(figure.image) — reset.scss 영향 무력화, 본문 폭 기준 표시
  ::v-deep figure.image {
    display: block;
    margin: 16px 0;
    max-width: 100%;

    img {
      width: 100%;
      height: auto;
      margin: 0;
    }
  }

  ::v-deep figure.image.image-style-side {
    max-width: 50%;
    margin-left: auto;
  }

  ::v-deep figure {
    margin: 16px 0;
  }

  ::v-deep table {
    width: 100%;
    border-collapse: collapse;
    word-break: break-all;
    margin: 16px 0;

    td, th {
      padding: 12px;
      border: 1px solid #ddd;
      word-break: break-all;

    }

    th {
      background-color: #f5f5f5;
      font-weight: bold;
      word-break: break-all;

    }
  }

  // CKEditor 인라인 서식 — 전역 reset.scss(font:inherit) 를 본문 영역에서만 복구
  // CKEditor5 출력 태그: bold=<strong>, italic=<i>, underline=<u>, strike=<s>
  ::v-deep strong,
  ::v-deep b {
    font-weight: bold;
    word-break: break-all;
  }

  ::v-deep em,
  ::v-deep i {
    font-style: italic;
    word-break: break-all;
  }

  ::v-deep u {
    text-decoration: underline;
  }

  ::v-deep s,
  ::v-deep strike,
  ::v-deep del {
    text-decoration: line-through;
  }
}

.category {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 20.78px;
  line-height: 20.78px;
  vertical-align: middle;
  color: #777;
  margin: 18px 0;
}

.title {
  border-bottom: 1px solid #E5E5E5;
  border-top: 1px solid #222;
  padding: 30px 0;
  font-weight: 700;
  font-size: 26px;
  line-height: 40px;
  letter-spacing: -1.12px;
  vertical-align: middle;
}

.images {
  margin: 40px 0;
  display: flex;
  flex-direction: column;
  gap: 20px;

  .review-image {
    width: 100%;
    height: auto;
    object-fit: cover;
    border-radius: 4px;
  }
}

.attachments {
  margin: 60px 0 40px;
  padding: 30px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;

  .attachments-title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
    color: #333;
    display: flex;
    align-items: center;
    gap: 8px;

    &:before {
      content: "📎";
      font-size: 18px;
    }
  }

  .attachment-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .attachment-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 14px 18px;
    background-color: white;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    text-decoration: none;
    color: #495057;
    transition: all 0.2s ease;
    cursor: pointer;

    &:hover {
      background-color: #e9ecef;
      border-color: #adb5bd;
      color: #212529;
      transform: translateX(4px);
    }

    .download-icon {
      flex-shrink: 0;
      color: #6c757d;
      transition: color 0.2s ease;
    }

    &:hover .download-icon {
      color: #495057;
    }

    .attachment-name {
      flex: 1;
      font-size: 16px;
      font-weight: 500;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .attachment-size {
      flex-shrink: 0;
      font-size: 14px;
      color: #6c757d;
    }
  }
}
</style>
